import '../css/app.css';

import { createInertiaApp } from '@inertiajs/react';
import { createRoot, hydrateRoot } from 'react-dom/client';

import CookieConsent from '@/Components/CookieConsent';
import { initClarity } from '@/Lib/clarity';
import { initGtm } from '@/Lib/gtm';
import { initMatomo } from '@/Lib/matomo';

createInertiaApp({
    title: (title) => (title ? `${title} · Fleischerei Tuitjer, Detern` : 'Fleischerei Tuitjer, Detern'),
    resolve: (name) => {
        const pages = import.meta.glob('./Pages/**/*.tsx');
        return pages[`./Pages/${name}.tsx`]();
    },
    setup({ el, App, props }) {
        const tree = (
            <>
                <App {...props} />
                <CookieConsent />
            </>
        );

        if (el.querySelector('*') !== null) {
            hydrateRoot(el, tree);
        } else {
            createRoot(el).render(tree);
        }

        initMatomo();
        initClarity();
        initGtm();
    },
});
